import { configureStore } from '@reduxjs/toolkit'
import invoiceReducer from './reducers/invoiceSlice'

export const store = configureStore({
  reducer: {
    invoice: invoiceReducer,
  },
})
